import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from "rxjs/operators";

@Injectable()
export class BearerInterceptor implements HttpInterceptor {
  constructor(private router: Router){}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = JSON.parse(localStorage.getItem('auth_app_token'));
    if (token) {
      const cloned = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + token.api_token),
      });

      return next.handle(cloned).pipe(
        catchError(this.handleError.bind(this))
      );
    } else if(req.url.includes('user-profile')){
      this.router.navigate(['login']);
      //return next.handle(req);
    } else{
      return next.handle(req).pipe(
        catchError(this.handleError.bind(this))
      );
    }
  }

  handleError(error: HttpErrorResponse) {
    if(error.status == 401){
      return throwError({message : 'please login'})
    }
    else {
      return throwError(error);
    }
  }
}